export const mapDiscount = (discount?: string) => {
    switch (discount) {
        case 'ADDITIONAL_COPY_DISCOUNT':
            return 'additionalCopyDiscount';
        case 'EXCLUSIVE_BORROWBOX_PROMOTION':
            return 'exclusiveBorrowboxPromotion';
        case 'CUSTOMER_DISCOUNT':
            return 'customerDiscount';
        default:
            return null;
    }
};
